import React, { useEffect, useState } from 'react';
import { Dialog } from "@mui/material";
import './Connection.css'
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import Avatar from "../../Assests/DefAvatar.png";
import Closeicon from "../../Assests/X.svg"
import { useSelector, useDispatch } from 'react-redux';
import { setValue } from '../../redux/valueSlice';
import { getPendingConnections } from '../../Services/Connection';
import { acceptConnectionRequests, rejectConnectionRequests } from '../../Services/SchedulesApi';
import Price from '../Container/Price/Price';
import { toggleSearchPageLoad } from '../../redux/valueSlice';
import { capitalizeNames } from '../../utils/nameUtils';

const PendingConnections = () => {
    const [requests, setRequests] = useState([]);

    const dispatch = useDispatch();
    const value = useSelector((state) => state?.value)

    const fetchPendingConnections = async () => {
        const { data } = await getPendingConnections();
        console.log("dataPending", data)
        const { nonStarredConnections } = data;
        setRequests(nonStarredConnections)
    };

    useEffect(() => {
        fetchPendingConnections();
    }, [value?.searchPageLoad])

    const CreatorCard = ({ FirstName,
        LastName,
        ShowCount,
        ProfileImageKey,
        ConnectionStatus,
        UserID,
        Rate,
        Collaborate }) => {

        const acceptRequest = async () => {
            console.log(`Approved user: ${UserID}`);
            const payload = {
                "SenderID": UserID,
                "ReceiverID": localStorage.getItem('user_id'),
                "Status": "ACCEPTED"
            };
            await acceptConnectionRequests(payload)
            await fetchPendingConnections();

            dispatch(toggleSearchPageLoad()); //to show latest status
        };

        const declineRequest = async () => {
            console.log(`Declined user: ${UserID}`);
            const payload = {
                "SenderID": UserID,
                "ReceiverID": localStorage.getItem('user_id'),
                "Status": "REJECTED"
            };
            await rejectConnectionRequests(payload)
            await fetchPendingConnections();
        };


        return (
            <div className="pending_connection_profile">
                <div className="pending_connection_profile_card">
                    <img src={ProfileImageKey ? ProfileImageKey : Avatar} />
                    <div className="pending_connection_profile_info" >
                        <div className="pending_connection_profile_head">
                            <div className="pending_connection_profile_name">{capitalizeNames(FirstName, LastName).fullName}</div>
                            <Price dollarSign rate={Rate} />
                        </div>
                        <div className="pending_connection_profile_sub">
                            <div className={Collaborate ?
                                'profilecard_collab_open_status' : 'profilecard_collab_close_status'
                            }></div>
                            <span className="pending_connection_profile_role">Podcast Ceater</span>
                        </div>
                    </div>
                </div>
                <div className="pending_connection_profile_button" >
                    <div className="profile_connection_button pointer decline" onClick={() => declineRequest()}>
                        <span>Decline</span>
                        <CloseSharpIcon />
                    </div>
                    <div className="profile_connection_button pointer accept" onClick={() => acceptRequest()}>
                        <span>Accept</span>
                        <CheckSharpIcon />
                    </div>
                </div>
            </div>
        );
    };

    const handleRequestClose = () => {
        dispatch(setValue({ requestShow: false }))
    }

    return (
        <Dialog open={value?.requestShow}
            sx={{
                "& .MuiDialog-paper": {
                    position: "absolute",
                    top: "10%",
                    right: value?.requestShow ? "34%" : "-100%",
                    transition: "right 0.1s ease-in-out",
                },
            }}
        >
            <div className='pending_connection_container'>
                <div className="pending_connection_header">
                    <span>Pending Requests</span>
                    <div className="pending_connection_close" onClick={handleRequestClose}>
                        <img src={Closeicon} />
                    </div>
                </div>
                <div className='pending_connection_list'>
                    {requests?.length > 0 ? (
                        requests?.map((element, index) => (
                            <CreatorCard key={index} {...element} />
                        ))
                    ) : (
                        <p className="text-center">No pending requests</p>
                    )}
                </div>
            </div>
        </Dialog>
    )
}

export default PendingConnections
